import { validateEmailAddress } from '../common';

export default class Panel {
  constructor(props) {
    /*
     ** [id, elem, field, name, ?action]
     */
    Object.assign(this, props);
  }

  get active() {
    return this.elem.classList.contains('visible');
  }

  get value() {
    return this.field.value;
  }

  set value(val) {
    this.field.value = val;
    if (this.field.nodeName.toLowerCase() === 'select') {
      this.field.selected = val;
    }
  }

  get optional() {
    return this.elem.hasAttribute('optional');
  }

  get required() {
    const required = this.elem.getAttribute('data-required');

    if (required === null) {
      return false;
    }

    return JSON.parse(required);
  }

  get data() {
    return {
      panel_id: this.id,
      panel_name: this.field.name,
      panel_value: this.value,
    };
  }

  toggle(cb) {
    this.elem.classList.toggle('visible');
    return typeof cb === 'function' ? cb() : true;
  }

  validate() {
    const profile = window.sooper_panel.props.profile;
    profile[this.name] = this.value;

    if (this.name === 'email_address' && profile[this.name] !== null) {
      const result = validateEmailAddress(profile[this.name]);
      // console.log(`Validate Email Response:`);
      // console.log(result);
      // if (window.sooper_panel.props.user_id === '901051xgIp') {
      //   return result;
      // }
      return result;
    }

    return profile[this.name] !== null;
    // if (profile[this.name] === null) {
    //   return false;
    // }

    // if (this.name === 'email_address') {
    //   validateEmailAddress(profile[this.name])
    // }

    // return true;
  }

  error() {
    this.field.classList.add('error');
  }
}
